"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendTypingIndicator;

var _setSendTyping = require("../actions/setSendTyping");

var _setSendTypingIndicator = require("../actions/setSendTypingIndicator");

var DEFAULT_STATE = false;

function sendTypingIndicator() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    // TODO: [P3] Take this deprecation code out when releasing on or after 2020 January 13
    case _setSendTyping.SET_SEND_TYPING:
      console.warn('Web Chat: "sendTyping" has been renamed to "sendTypingIndicator". Please use "sendTypingIndicator" instead. This deprecation migration will be removed on or after January 13 2020.');
      state = payload.sendTyping;
      break;

    case _setSendTypingIndicator.SET_SEND_TYPING_INDICATOR:
      state = payload.sendTypingIndicator;
      break;

    default:
      break;
  }

  return state;
}